export const iconMenu = [
    'icon_users',
    'icon_catalogs',
    'icon_libraries',
    'icon_application',
    'icon_settings',
    'icon_communications',
    'icon_folder',
    'icon_calendar',
    'icon_notification',
    'icon_text',
    'icon_default'
  ];